// Gate para trackers de analítica (GTM/GA) segun el consentimiento de CookieYes.
// Fuente de verdad: el evento "cookieyes_consent_update" (mismo contrato que ya
// usa app/index.html para RN4/RN8) — evita parsear el formato interno de la
// cookie "cookieyes-consent", que no está documentado.
const ANALYTICS_CATEGORY = "analytics"
const CONSENT_UPDATE_EVENT = "cookieyes_consent_update"

export const hasAnalyticsConsent = () =>
  typeof window !== "undefined" && window.__cookiesAnalyticsConsent === true

// Corre `callback` en cuanto haya consentimiento de analítica: de inmediato si
// ya se decidió (ver window.__cookiesAnalyticsConsent seteado en index.html),
// o cuando llegue el próximo cookieyes_consent_update con "analytics" aceptado.
export const onAnalyticsConsent = (callback) => {
  if (typeof document === "undefined") return

  if (hasAnalyticsConsent()) {
    callback()
    return
  }

  const handler = (eventData) => {
    const accepted = (eventData && eventData.detail && eventData.detail.accepted) || []
    if (accepted.indexOf(ANALYTICS_CATEGORY) !== -1) {
      document.removeEventListener(CONSENT_UPDATE_EVENT, handler)
      callback()
    }
  }

  document.addEventListener(CONSENT_UPDATE_EVENT, handler)
}
